import React from "react";

import { useViewport } from "@/contexts/ViewportContext";

import ContainerMobile from "./Container.mobile";
import ContainerWeb from "./Container.web";
import { ContainerProps } from "./types";

const Container = (props: ContainerProps) => {
  const { isWebMode } = useViewport();
  const Component = isWebMode ? ContainerWeb : ContainerMobile;
  return <Component {...props} />;
};

export default Container;
